export default __webpack_public_path__ + "static/media/612.75fd46f6.jpg";